// extracted by mini-css-extract-plugin
export default {"container":"TemplateList_container__yYBBR","colName":"TemplateList_colName__8q3uT","disabledRow":"TemplateList_disabledRow__GAtbK"};